import { usePosthog } from "~/composables/usePosthog";
import { startPageViewTracking } from "~/utils/page-view-tracking";

export default defineNuxtPlugin((nuxtApp) => {
  // By app:mounted, the initial navigation has resolved and the team-member middleware has loaded the team member
  nuxtApp.hook("app:mounted", () => {
    const { trackPageView } = usePosthog();

    // Not awaited: a tracking failure must not fail the app mount
    void startPageViewTracking(useRouter(), trackPageView);
  });
});
